import { Box, FormControl, FormHelperText, InputLabel, OutlinedInput } from '@mui/material';
import { FC } from 'react';
import { TStep3StripeProps } from './types';

export const Step3Stripe: FC<TStep3StripeProps> = ({
	APIKey,
	setAPIKey,
	accountName,
	setAccountName,
}) => {
	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: { xs: 'column', sm: 'row' },
				justifyContent: 'space-between',
				width: '100%',
				gap: '20px',
			}}
		>
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'left',
					gap: '20px',
					width: '100%',
				}}
			>
				<FormControl size="small" sx={{ width: '100%' }}>
					<InputLabel htmlFor="account-name">Stripe Account Name</InputLabel>
					<OutlinedInput
						sx={{
							borderRadius: '12px',
						}}
						id="account-name"
						label="Stripe Account Name"
						size="small"
						value={accountName ?? ''}
						onChange={(e) => setAccountName(e.target.value)}
					/>
					<FormHelperText id="account-name-helper-text">
						will be displayed in the list of active integrations
					</FormHelperText>
				</FormControl>
				<FormControl size="small" sx={{ width: '100%' }}>
					<InputLabel htmlFor="api-key">API Key</InputLabel>
					<OutlinedInput
						id="api-key"
						sx={{
							borderRadius: '12px',
						}}
						label="API Key"
						size="small"
						value={APIKey ?? ''}
						onChange={(e) => setAPIKey(e.target.value)}
					/>
					<FormHelperText id="api-key-helper-text">
						restricted key generated in your Stripe account settings
					</FormHelperText>
				</FormControl>
			</Box>
		</Box>
	);
};
